import { condition, fmtTemp, type WeatherView } from '../weather';
import WeatherIcon from './WeatherIcon';

interface Props {
  weather: WeatherView;
  onOpen: (rect: DOMRect) => void;
}

// Current conditions in the top bar; opens today's weather.
export default function WeatherChip({ weather, onOpen }: Props) {
  const c = weather.data.current;
  const loc = weather.data.location;
  if (!c || !loc) return null;
  const cond = condition(c.weather_code);
  return (
    <button
      type="button"
      onClick={(ev) => onOpen((ev.currentTarget as HTMLElement).getBoundingClientRect())}
      title={`${loc.name}${cond ? `: ${cond.label}` : ''}`}
      className="flex items-center gap-[6px] rounded-md px-2 py-[5px] text-[0.8rem] text-[var(--text-muted)] hover:bg-[var(--bg-hover)] hover:text-[var(--text)]"
    >
      {cond && <WeatherIcon kind={cond.icon} night={c.is_day === 0} size={17} />}
      <span className="tabular-nums">{fmtTemp(c.temperature_2m, weather.prefs.temperature_unit)}</span>
      {weather.prefs.locations.length > 1 && (
        <span className="max-w-[120px] truncate text-[var(--text-faint)]">{loc.name}</span>
      )}
    </button>
  );
}
